export const getSuccessFeesPerClaimColumnOptions = (): ReadonlyArray<{
  id: string;
  label: string;
  required?: boolean;
  mandatory?: boolean;
}> => [
  { id: "claim_number", label: "Claim", required: true, mandatory: true },
  { id: "appeal_date", label: "Appealed" },
  { id: "payer", label: "Payer" },
  { id: "user_displayName", label: "User" },
  { id: "paid_at_appeal", label: "Paid @ Appeal" },
  { id: "paid_now", label: "Paid Now" },
  { id: "payment_date", label: "Payment Date" },
  { id: "success_fee", label: "Success Fee", required: true },
];
